module.exports = __webpack_public_path__ + "images/ydlpk10c.a652.png";